/**
 * Nerva assessment specific screen names.
 *
 * Kept in a dependency-free leaf module so that shared screen sets (e.g. MedicareAccessConfig) can
 * reference these names without creating an import cycle with NervaControl (which spreads those
 * shared screen sets into its config). NervaControl re-exports these for backwards compatibility.
 */
export enum NervaControlScreenName {
  //HCP Flow screens
  HCPGreeting = 'hcpGreeting',
  YourProfession = 'yourProfession',
  HowManyIBSPatients = 'howManyIBSPatients',
  ClassificationDGBI = 'classificationDGBI',
  UnfortunateNoFit = 'unfortunateNoFit',
  CurrentlyUtilise = 'currentlyUtilise',
  TraditionalOptions = 'traditionalOptions',
  FamiliarWithGDH = 'familiarWithGDH',
  EffectiveOfGDH = 'effectiveOfGDH',
  AbilityToReferGDH = 'abilityToReferGDH',
  FamiliarWithNerva = 'familiarWithNerva',
  NervaIntroduction = 'nervaIntroduction',
  ReferredNerva = 'referredNerva',
  DoYouSeeThesePatients = 'doYouSeeThesePatients',
  PatientExamples = 'patientExamples',
  ReferralConfidence = 'referralConfidence',
  HCPCallToAction = 'hcpCallToAction',

  ReferralComparison = 'referralComparison',
  SocialProofClassifyIBSD = 'socialProofClassifyIBSD',
  SocialProofClassifyIBSC = 'socialProofClassifyIBSC',
  SocialProofClassifyIBSM = 'socialProofClassifyIBSM',
  Triggers = 'triggers',
  Symptoms = 'symptoms',
  ImpactLife = 'impactLife',
  EducationSignals = 'educationSignals',
  HowOften = 'howOften',
  DidTreatmentsWork = 'didTreatmentsWork',
  EducationUnderlyingReason = 'educationUnderlyingReason',
  Cotreatments = 'cotreatments',
  EducationCotreatments = 'educationCotreatments',
  EducationCertainFoods = 'educationCertainFoods',
  EducationStressCycle = 'educationStressCycle',
  IfFreeFromIbs = 'ifFreeFromIbs',
  LiveFreeNow = 'liveFreeNow',
  TimeCommitment = 'timeCommitment',
  TimeOfDayNerva = 'timeOfDayNerva',
  MoneyBackGuarantee = 'moneyBackGuarantee',
  BestSupported = 'BestSupported',
  RelateButterflies = 'relateButterflies',
  RelateDropping = 'relateDropping',
  RelateStress = 'relateStress',
  RelateEmotions = 'relateEmotions',
  RelateFood = 'relateFood',
  EducationExamples = 'educationExamples',
  RepairGutBrainConnection = 'repairGutBrainConnection',
  DaysPerWeekNerva = 'daysPerWeekNerva',
  BuildProgram = 'buildProgram',
  IbsResultsDate = 'ibsResultsDate',
  DataSummary = 'dataSummary',
  OtherGIIssues = 'otherGIIssues',
  IBDSubtype = 'ibdSubtype',
  WelcomeHcpReferred = 'welcomeHcpReferred',
  RedirectToPaymentASL = 'redirectToPaymentASL',
  AiLoading = 'aiLoading',
  AiLoadingContinued = 'aiLoadingContinued',
  DownloadAppAccessCode = 'downloadAppAccessCode',
  LowerGISymptoms = 'lowerGISymptoms',
  UpperGISymptoms = 'upperGISymptoms',
  InsuranceType = 'insuranceType',
  InsuranceProvider = 'insuranceProvider',
  WearableBiometrics = 'wearableBiometrics',
  GutBrainDiagnosis = 'gutBrainDiagnosis',
  StructuralConditions = 'structuralConditions',
  TriggersValidation = 'triggersValidation',
  EducationTriggers = 'educationTriggers',
  ProgramOverview = 'programOverview',
  DailySessions = 'dailySessions',

  // Musculoskeletal (MSK) pain screen (ACCESS MSK track qualification)
  MSKChronicPain = 'mskChronicPain',
  MSKPainInterference = 'mskPainInterference',
}

export const NEXT_BUTTON_TITLE = 'Next';
